"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RouterWrapper = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const appLoaders_1 = require("../../appLoaders");
const react_router_dom_1 = require("react-router-dom");
const RouterWrapper = ({ routerType = appLoaders_1.RouterType.BrowserRouter, basename, children }) => {
    return routerType === appLoaders_1.RouterType.HashRouter ? ((0, jsx_runtime_1.jsx)(react_router_dom_1.HashRouter, { basename: basename, children: children })) : ((0, jsx_runtime_1.jsx)(react_router_dom_1.BrowserRouter, { basename: basename, children: children }));
};
exports.RouterWrapper = RouterWrapper;
//# sourceMappingURL=RouterWrapper.js.map